import cubeGroupsSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const cubeGroupsActions = { ...actions, ...thunkActions };
export * as CubeGroupsTypes from './types';
export default cubeGroupsSlice;